export enum ActionType {
  GET_STATS_COUNT_DATA_REQUEST = 'get_stats_count_data_request',
  GET_STATS_COUNT_DATA_SUCCESS = 'get_stats_count_data_success',
  GET_STATS_COUNT_DATA_ERROR = 'get_stats_count_data_error'
}
